import window from '@atlas/tool/box/browser/window';

const scriptCache: Record<string, Promise<void> | undefined> = {};

export default function loadScript(src: string): Promise<void> {
    const existingPromise = scriptCache[src];

    if (existingPromise) return existingPromise;

    const scriptPromise = new Promise<void>((resolve, reject) => {
        const browserWindow = window as TBrowserWindow;
        const oldDefine = browserWindow.define;
        browserWindow.define = undefined;

        const script = document.createElement('script');
        script.src = src;
        script.onload = () => {
            browserWindow.define = oldDefine;
            resolve();
        };
        script.onerror = () => {
            browserWindow.define = oldDefine;
            reject(new Error(`Error loading script: ${src}`));
        };
        document.head.appendChild(script);
    });

    scriptCache[src] = scriptPromise;
    return scriptPromise;
}

// #region Types

type TBrowserWindow = Window & {
    define?: (...args: unknown[]) => void;
};

// #endregion

// #region Tests

if (import.meta.vitest) {
    const { describe, it } = import.meta.vitest;
    describe('loadScript', async () => {
        it.todo('🤷🏻‍♂️');
    });
}

// #endregion
